export default __webpack_public_path__ + "static/media/wallet.9c78e9e1.svg";